import React from 'react';
import { withI18n } from '@shopify/react-i18n';
import { Icon, TextField, TextStyle } from '@shopify/polaris';
import { SearchMinor } from '@shopify/polaris-icons';
import ProductList from 'src/components/views/common/product-list';
import { connect } from 'react-redux';
import _ from 'lodash';
import { getFormValues } from 'redux-form';

const PER_PAGE = 20;
const WEIGHT_TO_SIMILARITY = {
  0.25: 0.65,
  0.5: 0.6,
  0.75: 0.55,
  1: 0.5
}

const SemanticSimulator = (props) => {
  const { i18n, tenantId, externalInfo: { money_format }, formValues } = props;
  const { weight } = formValues;
  const [searchTerm, setSearchTerm] = React.useState('');
  const [withSemantic, setWithSemantic] = React.useState({
    page: 1, loading: false, result: {}
  });
  const [withoutSemantic, setWithoutSemantic] = React.useState({
    page: 1, loading: false, result: {}
  });
  const host = process.env.REACT_APP_ADMIN_V2_BASE_URL || 'https://staging.bc-solutions.net';

  let previewInterval = null;
  let queryWithSemantic = null;
  let queryWithoutSemantic = null;
  React.useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    previewInterval = setTimeout(() => {
      setWithSemantic({ ...withSemantic, loading: true });
      setWithoutSemantic({ ...withoutSemantic, loading: true });
      // eslint-disable-next-line react-hooks/exhaustive-deps
      queryWithSemantic = queryProducts(1, true);
      // eslint-disable-next-line react-hooks/exhaustive-deps
      queryWithoutSemantic = queryProducts(1, false);
      queryWithSemantic.then(res => {
        setWithSemantic({
          page: 1, loading: false, result: res, products: res.products
        });
      });
      queryWithoutSemantic.then(res => {
        setWithoutSemantic({
          page: 1, loading: false, result: res, products: res.products
        });
      });
    }, 500);
    return () => clearTimeout(previewInterval);
  }, [searchTerm, weight]);

  const queryProducts = (page, isSemantic) => {
    const params = new URLSearchParams({
      shop: tenantId,
      page: page,
      limit: PER_PAGE,
      sort: 'relevance',
      q: searchTerm,
      test_search: true,
      basic_search: !isSemantic,
      semantic_search: !!isSemantic,
      semantic_search_boost_value: isSemantic ? weight : undefined,
      semantic_search_similarity: isSemantic ? WEIGHT_TO_SIMILARITY[weight] || 0.5 : undefined
    }).toString();
    return fetch(`${host}/bc-sf-filter/search?${params}`).then(r => r.json());
  };

  const onLoadMore = (isSemantic) => {
    const data = isSemantic ? withSemantic : withoutSemantic;
    const setData = isSemantic ? setWithSemantic : setWithoutSemantic;
    setData({ ...data, loading: true });
    const nextPage = data.page + 1;
    queryProducts(nextPage, isSemantic).then(res => {
      setData({
        page: nextPage, loading: false, result: res, products: [...data.products, ...res.products]
      });
    });
  };

  const renderProductList = (isSemantic) => {
    const queryData = isSemantic ? withSemantic : withoutSemantic;
    return (
      <>
        <div className='header'>
          <span>{i18n.translate('AdminHTML.SemanticSearch.Simulator.header', {
            t1: <TextStyle variation='strong'>
              {i18n.translate(`AdminHTML.SemanticSearch.Simulator.${isSemantic ? 'with' : 'without'}`)}
            </TextStyle>
          })}</span>
          {!!queryData.result.total_product && (
            <span>{i18n.translate('AdminHTML.SemanticSearch.Simulator.result',
              { t1: queryData.result.total_product }
            )}</span>
          )}
        </div>
        <ProductList
          products={queryData.products}
          moneyFormat={money_format}
          onloadMore={() => onLoadMore(isSemantic)}
          loading={queryData.loading}
          page={queryData.page}
          perPage={PER_PAGE}
          hideLoadMore={queryData.page * PER_PAGE >= (queryData.result.total_product || 0)}
        />
      </>
    );
  };

  return (
    <div className='semantic-simulator'>
      <div className='content'>
          <span className='title'>
            {i18n.translate('AdminHTML.SemanticSearch.Simulator.title')}
          </span>
        <span className='description'>
            {i18n.translate('AdminHTML.SemanticSearch.Simulator.description')}
          </span>
      </div>
      <TextField
        onChange={(v) => setSearchTerm(v)}
        value={searchTerm}
        prefix={<Icon source={SearchMinor} color='base' />}
        placeholder={i18n.translate(
          'AdminHTML.SemanticSearch.Simulator.searchPlaceholder'
        )}
        clearButton
        onClearButtonClick={() => setSearchTerm('')}
      />
      <div className='product-list'>
        <div className='with-semantic'>
          {renderProductList(true)}
        </div>
        <div className='without-semantic'>
          {renderProductList(false)}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const tenantId = _.get(state.oauth, 'tenantApp.tenantId', '');
  const externalInfo = _.get(state.oauth, 'tenantApp.externalInfo', {});
  const formValues = getFormValues('SemanticSearchForm')(state);
  return {
    tenantId,
    externalInfo,
    formValues
  };
};


export default withI18n()(connect(mapStateToProps)(SemanticSimulator));